import authService from './authService';

let BASE_URL = process.env.REACT_APP_API_URL

async function loadConfig() {
    try {
        const response = await fetch("/config.json");
        const config = await response.json();
        BASE_URL = config.API_URL || BASE_URL; 
        //console.log("API URL Loaded:", BASE_URL);
    } catch (error) {
        console.error("Failed to load config.json. Using default .env API URL", error);
    }
}

loadConfig().then(() => {
    //console.log("Config initialized");
});
export async function getFunctions(): Promise<any> {
    try {

        const response = await authService.apiCall(`${BASE_URL}/functions/getAll`, {
            method: "GET",
           
        });

        

        const data = await response.json();
        if (!response.ok || !data.success) {
            if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
                throw new Error("Forbidden: You do not have permission to access this resource.");
            }
            throw new Error("Failed to fetch");
        }
        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}



export async function getFunctionsOrganization(query: string = '', perPage: number = 500, pageNo: number = 0): Promise<any> {
    try {
        const response = await authService.apiCall(`${BASE_URL}/functions/getAll?query=${query}&perPage=${perPage}&pageNo=${pageNo}`, {
            method: "GET",
        });

        const data = await response.json();
        if (!response.ok || !data.success) {
            if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
                throw new Error("Forbidden: You do not have permission to access this resource.");
            }
            throw new Error("Failed to fetch");
        }
        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}
export async function updateUserFunctions(userId: string, functionIds: string[]): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/user-functions/${userId}/functions`, {
      method: "POST",
    
      body: JSON.stringify({ functionIds }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      if (
        response.status === 401 ||
        response.status === 403 ||
        data.message === "Forbidden access"
      ) {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error(data.message || "Failed to update functions.");
    }

    return data;
  } catch (error: any) {
    throw new Error(error.message || "Unexpected error occurred while updating functions.");
  }
}

export async function getUserInThisFunction(function_id:any): Promise<any> {
    try {
        const response = await authService.apiCall(`${BASE_URL}/user-functions/getUserInThisFunction/${function_id}`, {
      
            method: "GET",
        });
        const data = await response.json();
        if (!response.ok || !data.success) {
            throw new Error("Failed to fetch");
        }
        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}



